<template>
  <div class="w-full h-full">
    <div class="!h-[calc(100%-100px)] !w-full overflow-auto">
      <el-table
        :data="tableData"
        highlight-current-row
        height="100%"
        ref="tableRef"
        v-loading="tableLoading"
      >
        <el-table-column label="序号" type="index" width="55"> </el-table-column>
        <el-table-column
          v-for="(item, index) in tableColumns"
          :key="index"
          :label="item.label"
          :width="item.width"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            <!-- <div class="truncate" v-if="item.prop === 'ticketState'">
              {{ getState(scope.row.ticketState) }}
            </div>
            <div v-else-if="item.prop === 'deviceCodes'">
              <span class="text-blue-500"> {{ scope.row.deviceCodes }} </span>
            </div> -->
            <div class="truncate">
              {{ scope.row[item.prop] }}
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-pagination
      small
      background
      @size-change="getTableData()"
      @current-change="getTableData()"
      :current-page.sync="page.pageNo"
      :page-size.sync="page.pageSize"
      :pager-count="5"
      layout="total, prev, pager, next"
      :total="page.total"
      class="text-center"
    ></el-pagination>
  </div>
</template>

<script>
import { WorkTicketApi } from '@wiz-api/ji-nan-re-dian'
import { workConfig } from './config'

const workTicketApi = new WorkTicketApi()

export default {
  name: 'workTicketList',
  props: {
    player: {
      type: Object,
      default: () => {},
    },
    transferProps: {
      type: Object,
      defalut: () => {},
    },
    cloudRender: {
      type: Object,
      default: () => {},
    },
    customProps: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      title: '工作票',
      tableData: [],
      tableLoading: false,
      page: {
        pageNo: 1,
        pageSize: 10,
        total: 0,
      },
    }
  },
  computed: {
    tableColumns() {
      return workConfig.pipelineSecondaryLedger.tableHead
    },
  },
  watch: {
    transferProps: {
      handler(data) {
        this.page.pageNo = 1
        this.getTableData()
      },
      deep: true,
      immediate: true,
    },
  },
  async mounted() {},
  methods: {
    getState(state) {
      switch (state) {
        case 'WaitCommit':
          return '待提交'
        case 'WaitApprove':
          return '待审批'
        case 'Executing':
          return '执行中'
        case 'Finished':
          return '已完成'
        case 'Cancel':
          return '已作废'
        case 'Archived':
          return '已归档'
        default:
          return ''
      }
    },
    indexMethod(index) {
      if (index < 10) {
        return `0${index + 1}`
      }
      return index + 1
    },
    async getTableData() {
      this.tableLoading = true
      const [err, res] = await workTicketApi.getPagedList({
        skipCount: (this.page.pageNo - 1) * this.page.pageSize,
        maxResultCount: this.page.pageSize,
      })
      this.tableLoading = false
      if (!err) {
        this.tableData = res.items
        this.page.total = res.totalCount
      }
    },
    async searchData() {
      this.page.pageNo = 1
      await this.getTableData()
    },
  },
  async beforeDestroy() {},
}
</script>

<style lang="scss" scoped>
::v-deep .el-loading-mask {
  background-color: #1e4960 !important;
  opacity: 1 !important;
}
::v-deep .el-pagination.is-background.el-pagination--small .el-pager li {
  min-width: 24px;
  margin: 0 5px;
  padding: 0 4px;
}
::v-deep {
  .el-table__body .el-table__row.hover-row > td.el-table__cell {
    background-color: transparent !important;
  }
}
</style>
